export default "__VITE_ASSET__DIEead$d__"